"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _icons = require("@chakra-ui/icons");

var _react = require("@chakra-ui/react");

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

var _react2 = _interopRequireWildcard(require("react"));

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _reactTable = require("react-table");

var _TableRow = _interopRequireDefault(require("./TableRow"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TheTable = function TheTable(props) {
  var _useState = (0, _react2.useState)(props.records),
      _useState2 = _slicedToArray(_useState, 2),
      records = _useState2[0],
      setRecords = _useState2[1];

  var _useState3 = (0, _react2.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedRows = _useState4[0],
      setSelectedRows = _useState4[1]; // currently only one selection is supported


  (0, _react2.useEffect)(function () {
    setRecords(props.records);
  }, [props.records]);

  var handleRowClick = function handleRowClick(_event, id) {
    var selection = [id];
    setSelectedRows(selection);
    props.onSelectionChange(selection);
    props.onContextMenuClose();
  };

  var handleRowDoubleClick = function handleRowDoubleClick(_event, id) {
    return props.onSelectionDoubleClick();
  };

  var handleRowContextMenu = function handleRowContextMenu(event, id) {
    event.preventDefault();
    var selection = [id];
    setSelectedRows(selection);
    props.onSelectionChange(selection);
    props.onContextMenu(event, id);
    return false;
  };

  var handleDnD = function handleDnD(dragIndex, dropIndex) {
    // Don't replace items with themselves
    if (dragIndex === dropIndex) {
      return;
    }

    var dropRecord = records[dropIndex]; // remove dragIndex from records if dropRecord is a dropzone

    if (dropRecord.isDropzone) {
      setRecords((0, _immutabilityHelper["default"])(records, {
        $splice: [[dragIndex, 1]]
      }));
      props.onDnD(dragIndex, dropIndex);
    }
  };

  var handleContainerClick = function handleContainerClick(event) {
    if (event.target === event.currentTarget) {
      setSelectedRows([]);
      props.onSelectionChange([]);
      props.onContextMenuClose();
    }
  };

  var handleContainerContextMenu = function handleContainerContextMenu(event) {
    if (event.target === event.currentTarget) {
      event.preventDefault();
      props.onSelectionChange([]);
      props.onContextMenu(event);
    }
  };

  var _useTable = (0, _reactTable.useTable)({
    data: records,
    columns: props.columns,
    initialState: props.initialState,
    //@ts-ignore
    autoResetFilters: false,
    autoResetSortBy: false
  }, _reactTable.useSortBy),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      rows = _useTable.rows,
      prepareRow = _useTable.prepareRow;

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDnd.DndProvider, {
    backend: _reactDndHtml5Backend.HTML5Backend,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
      onClick: handleContainerClick,
      onContextMenu: handleContainerContextMenu,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Table, _objectSpread(_objectSpread({}, getTableProps()), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Thead, {
          position: "sticky",
          top: 0,
          bg: (0, _react.useColorModeValue)('white', 'gray.800'),
          children: headerGroups.map(function (headerGroup) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Tr, _objectSpread(_objectSpread({}, headerGroup.getHeaderGroupProps()), {}, {
              children: headerGroup.headers.map(function (column) {
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Th, _objectSpread(_objectSpread({}, column.getHeaderProps(column.getSortByToggleProps())), {}, {
                  isNumeric: column.isNumeric,
                  w: column.width,
                  minW: 200,
                  children: [column.render('Header'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.chakra.span, {
                    pl: "4",
                    children: column.isSorted ? column.isSortedDesc ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.TriangleDownIcon, {
                      "aria-label": "sorted descending"
                    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.TriangleUpIcon, {
                      "aria-label": "sorted ascending"
                    }) : null
                  })]
                }));
              })
            }));
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Tbody, _objectSpread(_objectSpread({}, getTableBodyProps()), {}, {
          children: rows.map(function (row) {
            prepareRow(row);
            var index = row.index;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRow["default"], _objectSpread({
              index: index,
              row: row,
              onDnD: handleDnD,
              isSelected: selectedRows.includes(index),
              onClick: handleRowClick,
              onDoubleClick: handleRowDoubleClick,
              onContextMenu: handleRowContextMenu
            }, row.getRowProps()));
          })
        }))]
      }))
    })
  });
};

var _default = /*#__PURE__*/_react2["default"].memo(TheTable);

exports["default"] = _default;